import React from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';
import { useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowRight, faCalendarCheck, faEnvelope, faGaugeHigh, faMagnifyingGlass,
    faKey, faPen, faPlus, faTrashCan, faUserGroup,
} from '@fortawesome/free-solid-svg-icons';

import MyModalCreateAbo from '../components/AdminModal/MyModalCreateAbo';
import MyModalModifAbo from '../components/AdminModal/MyModalModifAbo';
import MyModalDeleteAbo from '../components/AdminModal/MyModalDeleteAbo';
import MyModalModifUser from '../components/AdminModal/MyModalModifUser';
import MyModalDeleteUser from '../components/AdminModal/MyModalDeleteUser';
import MyModalModifAccountPassword from '../components/AdminModal/MyModalModifAccountPassword';
import 'assets/styles/account.css';
import 'assets/styles/admin-dashboard.css';

const API_URL = 'https://eps.acces-editions.com/api';
const formatDate = (value) => (!value || !moment(value).isValid() ? '—' : moment(value).format('DD MMMM YYYY'));
const displayValue = (value) => (value === null || value === undefined || value === '' ? '—' : value);

export default function Dashboard() {
    const isMounted = React.useRef(true);
    const adminToken = useSelector((state) => state.userGlobal.user.token);
    const [email, setEmail] = React.useState('');
    const [allEmail, setAllEmail] = React.useState([]);
    const [aboInfo, setAboInfo] = React.useState([]);
    const [userInfo, setUserInfo] = React.useState([]);
    const [hasSearched, setHasSearched] = React.useState(false);
    const [isSearching, setIsSearching] = React.useState(false);
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const [selectedAccount, setSelectedAccount] = React.useState(null);

    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    const [modalIsOpen3, setIsOpen3] = React.useState(false);
    const [modalIsOpen4, setIsOpen4] = React.useState(false);
    const [modalIsOpen5, setIsOpen5] = React.useState(false);
    const [modalIsOpen6, setIsOpen6] = React.useState(false);
    const [indexSelected, setIndexSelected] = React.useState(null);
    const [indexSelectedAbo, setIndexSelectedAbo] = React.useState(null);

    React.useEffect(() => () => {
        isMounted.current = false;
    }, []);

    function openFromParent(modalNumber, index) {
        switch (modalNumber) {
            case 1: setIsOpen(true); break;
            case 2: setIsOpen2(true); setIndexSelectedAbo(index); break;
            case 3: setIsOpen3(true); setIndexSelectedAbo(index); break;
            case 4: setIsOpen4(true); setIndexSelected(index); break;
            case 5: setIsOpen5(true); setIndexSelected(index); break;
            case 6: setIsOpen6(true); break;
            default: break;
        }
    }

    function handleCloseModal(event, data) {
        switch (data) {
            case 1: setIsOpen(false); break;
            case 2: setIsOpen2(false); break;
            case 3: setIsOpen3(false); break;
            case 4: setIsOpen4(false); break;
            case 5: setIsOpen5(false); break;
            case 6: setIsOpen6(false); break;
            default: break;
        }
    }

    async function searchEmail(value) {
        const cleanSearch = value.trim();
        if (!cleanSearch) {
            NotificationManager.error('Saisissez un e-mail, un nom, un prénom ou un pseudo.', '', 3000);
            return;
        }
        const formData = new FormData();
        formData.append('search', cleanSearch);
        formData.append('email', cleanSearch);
        setIsSearching(true);
        setHasSearched(true);
        setAboInfo([]);
        setUserInfo([]);
        setSelectedAccount(null);
        try {
            const res = await axios.post(`${API_URL}/adminSearchEmail`, formData);
            if (!isMounted.current) return;
            const results = Array.isArray(res.data) ? res.data : [];
            setAllEmail(results);
            if (results.length === 0) NotificationManager.error('Aucun compte associé à cet email !', '', 3000);
        } catch (error) {
            if (!isMounted.current) return;
            setAllEmail([]);
            NotificationManager.error('La recherche n’a pas pu aboutir.', '', 3000);
        } finally {
            if (isMounted.current) setIsSearching(false);
        }
    }

    async function getInfoUser(idCompte) {
        const userFormData = new FormData();
        userFormData.append('id_compte', idCompte);
        const subscriptionFormData = new FormData();
        subscriptionFormData.append('id_compte', idCompte);
        const account = allEmail.find((item) => String(item.id_compte) === String(idCompte));
        setSelectedAccount(account || { id_compte: idCompte });
        setIsLoadingDetails(true);
        try {
            const [res, subscriptionRes] = await Promise.all([
                axios.post(`${API_URL}/adminSearchUser`, userFormData),
                axios.post(`${API_URL}/statutAbonnement`, subscriptionFormData).catch(() => ({ data: [] })),
            ]);
            if (!isMounted.current) return;
            if (Array.isArray(res.data) && res.data.length > 0) {
                const adminSubscriptions = Array.isArray(res.data[0].abo) ? res.data[0].abo : [];
                const activeSubscriptions = Array.isArray(subscriptionRes.data)
                    ? subscriptionRes.data.map((subscription) => ({
                        ...subscription,
                        id_compte: subscription.id_compte || idCompte,
                    }))
                    : [];
                const hasAdminSubscriptions = adminSubscriptions.some((subscription) => subscription && subscription.no_abo !== true);
                const subscriptions = hasAdminSubscriptions ? adminSubscriptions : activeSubscriptions;

                setAboInfo(subscriptions.length > 0 ? subscriptions : [{ no_abo: true }]);
                setUserInfo(Array.isArray(res.data[0].user) ? res.data[0].user : []);
            } else {
                setAboInfo([]);
                setUserInfo([]);
                NotificationManager.error('Une erreur est survenue', '', 3000);
            }
        } catch (error) {
            if (!isMounted.current) return;
            NotificationManager.error('Les informations du compte sont indisponibles.', '', 3000);
        } finally {
            if (isMounted.current) setIsLoadingDetails(false);
        }
    }

    const hasSubscription = aboInfo.length > 0 && (aboInfo[0].no_abo === false || aboInfo[0].no_abo === undefined);
    const hasUsers = userInfo.length > 0 && (userInfo[0].no_user === false || userInfo[0].no_user === undefined);

    return (
        <>
            <MyModalCreateAbo
                IsModalOpened={modalIsOpen}
                onCloseModal={handleCloseModal}
                getInfoUser={getInfoUser}
                idCompte={selectedAccount && selectedAccount.id_compte}
            />
            <MyModalModifAbo
                IsModalOpened={modalIsOpen2}
                onCloseModal={handleCloseModal}
                getInfoUser={getInfoUser}
                allInfo={aboInfo}
                indexSelected={indexSelectedAbo}
                idCompte={selectedAccount && selectedAccount.id_compte}
            />
            <MyModalDeleteAbo IsModalOpened={modalIsOpen3} onCloseModal={handleCloseModal} getInfoUser={getInfoUser} allInfo={aboInfo} indexSelected={indexSelectedAbo} />
            <MyModalModifUser IsModalOpened={modalIsOpen4} onCloseModal={handleCloseModal} getInfoUser={getInfoUser} userInfo={userInfo} indexSelected={indexSelected} />
            <MyModalDeleteUser IsModalOpened={modalIsOpen5} onCloseModal={handleCloseModal} getInfoUser={getInfoUser} userInfo={userInfo} indexSelected={indexSelected} />
            <MyModalModifAccountPassword IsModalOpened={modalIsOpen6} onCloseModal={handleCloseModal} account={selectedAccount} adminToken={adminToken} />

            <main className="ae-account-page ae-admin-page">
                <span className="ae-account-ring ae-account-ring--violet" />
                <span className="ae-account-ring ae-account-ring--green" />
                <span className="ae-account-ring ae-account-ring--gold" />
                <div className="ae-account-content ae-admin-content">
                    <header className="ae-admin-page-heading">
                        <span className="ae-admin-page-icon"><FontAwesomeIcon icon={faGaugeHigh} /></span>
                        <div className="ae-account-heading">
                            <h1>Tableau de bord</h1>
                            <p>Recherchez un compte et gérez ses abonnements et ses utilisateurs.</p>
                        </div>
                    </header>

                    <section className="ae-admin-card ae-admin-search-card">
                        <div className="ae-admin-card-heading">
                            <span className="ae-admin-card-icon ae-admin-card-icon--blue"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                            <div><h2>Recherche de comptes</h2><p>Recherchez par e-mail, nom, prénom ou pseudo utilisateur.</p></div>
                        </div>
                        <form className="ae-admin-search-form" onSubmit={(event) => { event.preventDefault(); searchEmail(email); }}>
                            <label htmlFor="searchEmail">E-mail, nom, prénom ou pseudo</label>
                            <div className="ae-admin-search-control">
                                <span aria-hidden="true"><FontAwesomeIcon icon={faEnvelope} /></span>
                                <input id="searchEmail" value={email} type="search" placeholder="Ex. dupont, marie ou @ecole.fr" onChange={(event) => setEmail(event.target.value)} />
                            </div>
                            <button className="ae-admin-primary-button" type="submit" disabled={isSearching}>
                                <span>{isSearching ? 'Recherche…' : 'Rechercher'}</span><FontAwesomeIcon icon={faMagnifyingGlass} />
                            </button>
                        </form>

                        {allEmail.length > 0 ? (
                            <div className="ae-admin-table-wrap ae-admin-search-results">
                                <table className="ae-admin-table ae-admin-table--accounts">
                                    <thead><tr><th>Identifiant</th><th>Nom et prénom</th><th>E-mail</th><th>Utilisateur(s)</th><th>Actions</th></tr></thead>
                                    <tbody>{allEmail.map((row) => (
                                        <tr key={row.id_compte}>
                                            <td data-label="Identifiant"><strong>#{row.id_compte}</strong></td>
                                            <td data-label="Nom et prénom">{displayValue([row.prenom, row.nom].filter(Boolean).join(' '))}</td>
                                            <td data-label="E-mail">{displayValue(row.email)}</td>
                                            <td data-label="Utilisateur(s)">{displayValue(row.utilisateurs)}</td>
                                            <td data-label="Actions"><button className="ae-admin-row-button" type="button" onClick={() => getInfoUser(row.id_compte)} disabled={isLoadingDetails}><span>Consulter</span><FontAwesomeIcon icon={faArrowRight} /></button></td>
                                        </tr>
                                    ))}</tbody>
                                </table>
                            </div>
                        ) : hasSearched && !isSearching ? <div className="ae-admin-empty">Aucun compte ne correspond à cette recherche.</div> : null}
                    </section>

                    {selectedAccount && (
                        <div className="ae-admin-selected-account-row">
                            <div className="ae-admin-selected-account"><span>Compte sélectionné</span><strong>{selectedAccount.email || `#${selectedAccount.id_compte}`}</strong></div>
                            <button className="ae-admin-account-password-button" type="button" onClick={() => openFromParent(6)}>
                                <FontAwesomeIcon icon={faKey} /><span>Modifier le mot de passe</span>
                            </button>
                        </div>
                    )}
                    {isLoadingDetails && <div className="ae-admin-loading">Chargement des informations du compte…</div>}

                    {selectedAccount && !isLoadingDetails && (
                        <section className="ae-admin-card">
                            <div className="ae-admin-card-heading ae-admin-card-heading--actions">
                                <div className="ae-admin-card-title">
                                    <span className="ae-admin-card-icon ae-admin-card-icon--purple"><FontAwesomeIcon icon={faCalendarCheck} /></span>
                                    <div><h2>Abonnements</h2><p>Consultez et gérez les accès associés au compte.</p></div>
                                </div>
                                {!hasSubscription && <button className="ae-admin-primary-button ae-admin-primary-button--compact" type="button" onClick={() => openFromParent(1)}><FontAwesomeIcon icon={faPlus} /><span>Créer un abonnement</span></button>}
                            </div>
                            {hasSubscription ? (
                                <div className="ae-admin-table-wrap">
                                    <table className="ae-admin-table ae-admin-table--subscriptions">
                                        <thead><tr><th>Paiement</th><th>Début</th><th>Fin</th><th>Cycle 1</th><th>Cycle 2</th><th>Cycle 3</th><th>Actions</th></tr></thead>
                                        <tbody>{aboInfo.map((row, index) => (
                                            <tr key={row.id_abonnement || index}>
                                                <td data-label="Paiement">{formatDate(row.date_paiement)}</td><td data-label="Début">{formatDate(row.date_debut)}</td><td data-label="Fin">{formatDate(row.date_fin)}</td>
                                                {[row.cycle_1, row.cycle_2, row.cycle_3].map((cycle, cycleIndex) => <td data-label={`Cycle ${cycleIndex + 1}`} key={cycleIndex}><span className={`ae-admin-status${Number(cycle) === 1 ? ' is-active' : ''}`}>{Number(cycle) === 1 ? 'Actif' : 'Non'}</span></td>)}
                                                <td data-label="Actions"><div className="ae-admin-actions"><button className="ae-admin-icon-button ae-admin-icon-button--edit" type="button" onClick={() => openFromParent(2, index)} aria-label="Modifier l’abonnement"><FontAwesomeIcon icon={faPen} /></button><button className="ae-admin-icon-button ae-admin-icon-button--delete" type="button" onClick={() => openFromParent(3, index)} aria-label="Supprimer l’abonnement"><FontAwesomeIcon icon={faTrashCan} /></button></div></td>
                                            </tr>
                                        ))}</tbody>
                                    </table>
                                </div>
                            ) : <div className="ae-admin-empty">Aucun abonnement actif pour ce compte.</div>}
                        </section>
                    )}

                    {userInfo.length > 0 && !isLoadingDetails && (
                        <section className="ae-admin-card">
                            <div className="ae-admin-card-heading">
                                <span className="ae-admin-card-icon ae-admin-card-icon--green"><FontAwesomeIcon icon={faUserGroup} /></span>
                                <div><h2>Utilisateurs</h2><p>Consultez et gérez les profils et appareils autorisés.</p></div>
                            </div>
                            {hasUsers ? (
                                <div className="ae-admin-table-wrap">
                                    <table className="ae-admin-table ae-admin-table--users">
                                        <thead><tr><th>Pseudo</th><th>Code secret</th><th>Appareil 1</th><th>Adresse MAC 1</th><th>Appareil 2</th><th>Adresse MAC 2</th><th>Actions</th></tr></thead>
                                        <tbody>{userInfo.map((row, index) => (
                                            <tr key={row.id_user || index}>
                                                <td data-label="Pseudo"><strong>{displayValue(row.pseudo)}</strong></td><td data-label="Code secret"><span className="ae-admin-pin">{displayValue(row.pin_code)}</span></td><td data-label="Appareil 1">{displayValue(row.device_name_1)}</td><td data-label="Adresse MAC 1" className="ae-admin-mac">{displayValue(row.mac_adress_1)}</td><td data-label="Appareil 2">{displayValue(row.device_name_2)}</td><td data-label="Adresse MAC 2" className="ae-admin-mac">{displayValue(row.mac_adress_2)}</td>
                                                <td data-label="Actions"><div className="ae-admin-actions"><button className="ae-admin-icon-button ae-admin-icon-button--edit" type="button" onClick={() => openFromParent(4, index)} aria-label="Modifier l’utilisateur"><FontAwesomeIcon icon={faPen} /></button><button className="ae-admin-icon-button ae-admin-icon-button--delete" type="button" onClick={() => openFromParent(5, index)} aria-label="Supprimer l’utilisateur"><FontAwesomeIcon icon={faTrashCan} /></button></div></td>
                                            </tr>
                                        ))}</tbody>
                                    </table>
                                </div>
                            ) : <div className="ae-admin-empty">Aucun utilisateur associé à ce compte.</div>}
                        </section>
                    )}
                    <p className="ae-account-copyright">© 2024 Accès EPS — Tous droits réservés</p>
                </div>
            </main>
        </>
    );
}
